module.exports = __webpack_public_path__ + "static/media/fhp-logo.c4a7c24b.png";